import {h, Component} from 'preact';
import Cookies from 'universal-cookie';
import authContainer from '../tags/auth-container';
import ChangePasswordService from '../../services/changePasswordService';
import ChangePasswordIntro from './change-password-intro';
import UpdateOldPassword from './update-old-password';
import PasswordUpdated from './password-updated';

export class ChangePassword extends Component {
    constructor() {
        super();
        this.cookies = new Cookies();
        this.state = {
            step: 'intro',
            password: '',
            connectedDevices: [],
            connectedApps: [],
            userCulture: ''
        }
    }

    componentDidMount() {
        document.title = 'Change password | workplace_';
        const connectedDevicesPromise = ChangePasswordService.getConnectedDevices();
        const connectedAppsPromise = ChangePasswordService.getConnectedApps();
        Promise.all([connectedDevicesPromise, connectedAppsPromise])
            .then((responses) => {
                this.setState({
                    connectedDevices: responses[0].data,
                    connectedApps: responses[1].data
                });
            }, error => {
                if (error.response.status === 401) {
                    this.props.history.push({
                        pathname: '/',
                        search: location.search
                    })
                }
            });
        const userCulture = this.cookies.get('userCulture') || 'en-US';
        this.setState({ userCulture });
    }

    setStep = step => {
        this.setState({ step });
    };

    setPassword = password => {
        this.setState({ password });
    };

    getPassword = () => {
        return this.state.password;
    };

    renderChangePasswordSteps = step => {
        switch (step) {
            case 'intro':
                return <ChangePasswordIntro setStep={this.setStep}
                                            connectedDevices={this.state.connectedDevices}
                                            connectedApps={this.state.connectedApps}
                                            userCulture={this.state.userCulture}/>;
            case 'updateOldPassword':
                return <UpdateOldPassword setStep={this.setStep}
                                          setPassword={this.setPassword}
                                          getPassword={this.getPassword}/>;
            case 'passwordUpdated':
                return <PasswordUpdated getPassword={this.getPassword}/>;
        }
    };

    render({}, {step}) {
        return(
            <section className='auth-modal-container change-password'>
                {this.renderChangePasswordSteps(step)}
            </section>
        )
    }
}

export default authContainer(ChangePassword);




// WEBPACK FOOTER //
// ./src/scripts/views/change-password/change-password.js